import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-down",
  "use": "icon-down-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-down\">\r\n    <path fill-rule=\"evenodd\" d=\"M14.81 5.228a.375.375 0 0 1 0 .531l-6.544 6.544a.375.375 0 0 1-.532 0L1.191 5.76a.375.375 0 0 1 0-.53l.618-.62a.375.375 0 0 1 .532 0L8 10.256l5.66-5.647a.375.375 0 0 1 .53 0l.62.62z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/down.svg
// module id = LHwD
// module chunks = 10